import React, { useCallback } from "react";
import ReadOnlyListPanel from "../../components/ReadOnlyListPanel";
import { getPublicPromos } from "../../api/classicSiteHoodieApi";

export default function PublicPromosPage() {
  const load = useCallback(() => getPublicPromos(), []);

  return (
    <ReadOnlyListPanel
      title="Active public promos (hoodie API)"
      load={load}
      render={(rows) => (
        <ul className="cs-list">
          {(rows || []).map((promo) => (
            <li key={promo.id} className="cs-list__item">
              <strong>{promo.name}</strong>
              {promo.promo_code ? (
                <span> — code: {promo.promo_code}</span>
              ) : null}
              {promo.entry?.business_name ? (
                <div className="cs-list__meta">{promo.entry.business_name}</div>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    />
  );
}
